import React from "react";
import { Link } from "react-router-dom";
import { Offer } from "../utils/API";

const AlsoLikeRecommendations: React.FC<{ alsoLikeListData: Offer[] }> = ({
  alsoLikeListData,
}) => {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 md:px-[76px] px-6">
        {alsoLikeListData?.map((item) => {
          const logoUrl = (item.brand_logo || "")
            .replace("[size]", "200")
            .replace("[format]", "png");
          return (
            <Link
              to={`/branddiscountcode?offer_id=${item.offer_id}&store=${item.store}`}
              key={item.offer_id}
              target="_top"
              rel="noopener noreferrer"
            >
              <div className="cursor-pointer pt-4 pb-5 pl-3 md:py-[30px] md:pl-[18px] min-h-[90px] pr-2 flex items-center shadow-card bg-white rounded-[10px] relative overflow-hidden transition-all duration-200 hover:scale-[1.02] hover:shadow-lg">
                <div className="flex items-center gap-3 flex-1 mr-2 md:mr-3">
                  <div className="rounded-[10px] bg-white border border-[#fb7401] md:border-[1.5px] md:rounded-lg flex-center">
                    <img
                      src={logoUrl}
                      alt={item.categories}
                      referrerPolicy="no-referrer"
                      crossOrigin="anonymous"
                      loading="lazy"
                      decoding="async"
                      fetch-priority="auto"
                      width="60"
                      height="60"
                      className="w-[60px] h-[60px] md:w-[90px] md:h-[90px] rounded-[10px] md:rounded-lg object-contain px-1"
                    />
                  </div>
                  <div className="flex flex-col flex-1 min-w-0 gap-1 md:gap-1.5">
                    <div className="font-bold text-base leading-5 md:text-xl md:leading-7 text-[#130300] line-clamp-1 md:line-clamp-2">
                      {item.title}
                    </div>
                    <div className="text-sm md:text-base font-semibold leading-4 md:leading-6 text-[#fb7401] line-clamp-1">
                      {item.label}
                    </div>
                    {/* <div className="w-auto flex items-center">
                      <div className="w-auto bg-[#4392e7] text-white text-xs md:text-lg px-2.5 py-1 rounded-[4px] font-medium leading-4 md:leading-[22px]  line-clamp-1">
                        9,489 人が利用しました
                      </div>
                    </div> */}
                  </div>
                </div>
                {/* <div className="flex flex-col items-center justify-center w-[60px] md:w-[76px] lg:w-[90px] h-full absolute right-0 top-0 border-l border-[#ef312bcc] border-dashed bottom-0 text-[#ef312b] font-extrabold text-lg md:text-[28px] leading-6 md:leading-9">
                  <span>全</span>
                  <span>20</span>
                  <span>枚</span>
                </div> */}
              </div>
            </Link>
          );
        })}
      </div>
    </>
  );
};

export default AlsoLikeRecommendations;
